/**
 * 项目商品池页签 - 状态管理
 */
import type {
  ProjectMaterialPoolDTO,
  ProjectPoolProject,
} from '@/api/projectPoolApi'

/** 状态页签，取值与项目商品池接口 statusTab 一致；首次进入、切换项目默认【已上架】（PRD SCP-TAB-001 BR-11） */
export const STATUS_TABS = [
  { key: 'ALL', label: '全部' },
  { key: 'ON_SHELF', label: '已上架' },
  { key: 'OTHER', label: '其他状态' },
]
export const DEFAULT_STATUS_TAB = 'ON_SHELF'

/** 每页条数：卡片与表格共用，默认 30 条、可切换（与 MPM 项目商品池一致，用户确认） */
export const DEFAULT_PAGE_SIZE = 30
export const PAGE_SIZE_OPTIONS = ['30', '50', '100']

/** 展示模式：首次进入默认商品卡片；切换页签再回来保持上次的模式（用户 2026-10-13，覆盖 PRD BR-12） */
export type ViewMode = 'card' | 'table'

/** 业务筛选条件，字段名与项目商品池接口一致 */
export interface PoolFilter {
  xhCode?: string
  customerTitle?: string
  brandName?: string
  customerCategoryName?: string
  remark?: string
  standardCode?: string
  materialCode?: string
}

/** 一次查询的上下文 */
export interface PoolQuery {
  platformCode?: string
  filter: PoolFilter
  statusTab: string
  pageNo: number
  pageSize: number
}

export interface State extends PoolQuery {
  projects: ProjectPoolProject[] // 当前服务商可查看的项目
  projectsLoading: boolean
  list: ProjectMaterialPoolDTO[]
  total: number
  loading: boolean
  viewMode: ViewMode
  selectedIds: string[] // 当前页已勾选的记录 id，卡片与表格共用
  detailCode?: string // 详情抽屉中的咸亨编码，有值即打开
  exporting: boolean // 导出提交中，防重复点击
}

export const initialState: State = {
  projects: [],
  projectsLoading: true,
  platformCode: undefined,
  filter: {},
  statusTab: DEFAULT_STATUS_TAB,
  pageNo: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  list: [],
  total: 0,
  loading: false,
  viewMode: 'card',
  selectedIds: [],
  detailCode: undefined,
  exporting: false,
}

type Action =
  | { type: 'setProjects'; payload: ProjectPoolProject[] }
  | { type: 'setProjectsLoading'; payload: boolean }
  | { type: 'setQuery'; payload: PoolQuery }
  | {
      type: 'setResult'
      payload: { list: ProjectMaterialPoolDTO[]; total: number }
    }
  | { type: 'setLoading'; payload: boolean }
  | { type: 'setViewMode'; payload: ViewMode }
  | { type: 'setSelectedIds'; payload: string[] }
  | { type: 'setDetailCode'; payload?: string }
  | { type: 'setExporting'; payload: boolean }
  | { type: 'reloadState'; payload: State }

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'reloadState':
      return action.payload
    case 'setProjects':
      return { ...state, projects: action.payload }
    case 'setProjectsLoading':
      return { ...state, projectsLoading: action.payload }
    case 'setQuery':
      // 发起查询：记录查询上下文并清空勾选（BR-13）
      return { ...state, ...action.payload, selectedIds: [] }
    case 'setResult':
      return { ...state, ...action.payload }
    case 'setLoading':
      return { ...state, loading: action.payload }
    case 'setViewMode':
      return { ...state, viewMode: action.payload }
    case 'setSelectedIds':
      return { ...state, selectedIds: action.payload }
    case 'setDetailCode':
      return { ...state, detailCode: action.payload }
    case 'setExporting':
      return { ...state, exporting: action.payload }
    default:
      return state
  }
}

export const setProjectsAction = (payload: ProjectPoolProject[]): Action => ({
  type: 'setProjects',
  payload,
})

export const setProjectsLoadingAction = (payload: boolean): Action => ({
  type: 'setProjectsLoading',
  payload,
})

export const setQueryAction = (payload: PoolQuery): Action => ({
  type: 'setQuery',
  payload,
})

/** 查询结果；无项目或查询失败时传空列表，清空上一项目数据 */
export const setResultAction = (payload: {
  list: ProjectMaterialPoolDTO[]
  total: number
}): Action => ({ type: 'setResult', payload })

export const setLoadingAction = (payload: boolean): Action => ({
  type: 'setLoading',
  payload,
})

export const setViewModeAction = (payload: ViewMode): Action => ({
  type: 'setViewMode',
  payload,
})

export const setSelectedIdsAction = (payload: string[]): Action => ({
  type: 'setSelectedIds',
  payload,
})

/** 打开（传咸亨编码）/ 关闭（不传）详情抽屉；不影响列表上下文 */
export const setDetailCodeAction = (payload?: string): Action => ({
  type: 'setDetailCode',
  payload,
})

export const setExportingAction = (payload: boolean): Action => ({
  type: 'setExporting',
  payload,
})

/** 整体替换状态：从其他页面切回来时用页面缓存恢复 */
export const reloadStateAction = (payload: State): Action => ({
  type: 'reloadState',
  payload,
})

export default reducer
/**
 * 项目商品池页签 - 状态管理
 */
import type {
  ProjectMaterialPoolDTO,
  ProjectPoolProject,
} from '@/api/projectPoolApi'

/** 状态页签，取值与项目商品池接口 statusTab 一致；首次进入、切换项目默认【已上架】（PRD SCP-TAB-001 BR-11） */
export const STATUS_TABS = [
  { key: 'ALL', label: '全部' },
  { key: 'ON_SHELF', label: '已上架' },
  { key: 'OTHER', label: '其他状态' },
]
export const DEFAULT_STATUS_TAB = 'ON_SHELF'

/** 每页条数：卡片与表格共用，默认 30 条、可切换（与 MPM 项目商品池一致，用户确认） */
export const DEFAULT_PAGE_SIZE = 30
export const PAGE_SIZE_OPTIONS = ['30', '50', '100']

/** 展示模式：首次进入默认商品卡片；切换页签再回来保持上次的模式（用户 2026-10-13，覆盖 PRD BR-12） */
export type ViewMode = 'card' | 'table'

/** 业务筛选条件，字段名与项目商品池接口一致 */
export interface PoolFilter {
  xhCode?: string
  customerTitle?: string
  brandName?: string
  customerCategoryName?: string
  remark?: string
  standardCode?: string
  materialCode?: string
}

/** 一次查询的上下文 */
export interface PoolQuery {
  platformCode?: string
  filter: PoolFilter
  statusTab: string
  pageNo: number
  pageSize: number
}

export interface State extends PoolQuery {
  projects: ProjectPoolProject[] // 当前服务商可查看的项目
  projectsLoading: boolean
  list: ProjectMaterialPoolDTO[]
  total: number
  loading: boolean
  viewMode: ViewMode
  selectedIds: string[] // 当前页已勾选的记录 id，卡片与表格共用
  detailCode?: string // 详情抽屉中的咸亨编码，有值即打开
  exporting: boolean // 导出提交中，防重复点击
}

export const initialState: State = {
  projects: [],
  projectsLoading: true,
  platformCode: undefined,
  filter: {},
  statusTab: DEFAULT_STATUS_TAB,
  pageNo: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  list: [],
  total: 0,
  loading: false,
  viewMode: 'card',
  selectedIds: [],
  detailCode: undefined,
  exporting: false,
}

type Action =
  | { type: 'setProjects'; payload: ProjectPoolProject[] }
  | { type: 'setProjectsLoading'; payload: boolean }
  | { type: 'setQuery'; payload: PoolQuery }
  | {
      type: 'setResult'
      payload: { list: ProjectMaterialPoolDTO[]; total: number }
    }
  | { type: 'setLoading'; payload: boolean }
  | { type: 'setViewMode'; payload: ViewMode }
  | { type: 'setSelectedIds'; payload: string[] }
  | { type: 'setDetailCode'; payload?: string }
  | { type: 'setExporting'; payload: boolean }
  | { type: 'reloadState'; payload: State }

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'reloadState':
      return action.payload
    case 'setProjects':
      return { ...state, projects: action.payload }
    case 'setProjectsLoading':
      return { ...state, projectsLoading: action.payload }
    case 'setQuery':
      // 发起查询：记录查询上下文并清空勾选（BR-13）
      return { ...state, ...action.payload, selectedIds: [] }
    case 'setResult':
      return { ...state, ...action.payload }
    case 'setLoading':
      return { ...state, loading: action.payload }
    case 'setViewMode':
      return { ...state, viewMode: action.payload }
    case 'setSelectedIds':
      return { ...state, selectedIds: action.payload }
    case 'setDetailCode':
      return { ...state, detailCode: action.payload }
    case 'setExporting':
      return { ...state, exporting: action.payload }
    default:
      return state
  }
}

export const setProjectsAction = (payload: ProjectPoolProject[]): Action => ({
  type: 'setProjects',
  payload,
})

export const setProjectsLoadingAction = (payload: boolean): Action => ({
  type: 'setProjectsLoading',
  payload,
})

export const setQueryAction = (payload: PoolQuery): Action => ({
  type: 'setQuery',
  payload,
})

/** 查询结果；无项目或查询失败时传空列表，清空上一项目数据 */
export const setResultAction = (payload: {
  list: ProjectMaterialPoolDTO[]
  total: number
}): Action => ({ type: 'setResult', payload })

export const setLoadingAction = (payload: boolean): Action => ({
  type: 'setLoading',
  payload,
})

export const setViewModeAction = (payload: ViewMode): Action => ({
  type: 'setViewMode',
  payload,
})

export const setSelectedIdsAction = (payload: string[]): Action => ({
  type: 'setSelectedIds',
  payload,
})

/** 打开（传咸亨编码）/ 关闭（不传）详情抽屉；不影响列表上下文 */
export const setDetailCodeAction = (payload?: string): Action => ({
  type: 'setDetailCode',
  payload,
})

export const setExportingAction = (payload: boolean): Action => ({
  type: 'setExporting',
  payload,
})

/** 整体替换状态：从其他页面切回来时用页面缓存恢复 */
export const reloadStateAction = (payload: State): Action => ({
  type: 'reloadState',
  payload,
})

export default reducer
